import React, { useState } from "react";
import Contacted from "./Activity/Contacted";
import Viewed from "./Activity/Viewed";
import Recent from "./Activity/RecentSearchList";
import Wishlist from "./Activity/Wishlist";

function Activity({stateObj}) {
  const [currentDiv, setCurrentDiv] = useState("contact");
  return (
    <div class="card mb-0">
      <div class="card-header">
        <h3 class="card-title">Recent Activity</h3>
      </div>
      <div class="card-body">
        
        <div class="ads-tabs">
          <div class="tabs-menus">
            <ul class="nav panel-tabs">
              <li class="">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentDiv("contact");
                  }}
                  class={currentDiv === "contact" ? "active" : ""}
                >
                  Contacted
                </a>
              </li>
              <li class="">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentDiv("view");
                  }}
                  class={currentDiv === "view" ? "active" : ""}
                >
                  Viewed
                </a>
              </li>
              <li class="">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentDiv("recent");
                  }}
                  class={currentDiv === "recent" ? "active" : ""}
                >
                  Recent Searches
                </a>
              </li>
              <li class="">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentDiv("wishlist");
                  }}
                  class={currentDiv === "wishlist" ? "active" : ""}
                >
                  Favourites
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            <div className="tab-pane active userprof-tab">

              {currentDiv === "contact" && <Contacted stateObj={stateObj}/>}
              {currentDiv === "view" && <Viewed />}
              {currentDiv === "recent" && <Recent />}
              {currentDiv === "wishlist" && <Wishlist />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Activity;
